var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F27E30;}\n\t.st1{fill:#C64C1C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "st0",
    d: "M440.2,70.6L440.2,70.6l-107-0.1c-23.7,0-37.7,22.9-26.3,42.7l54.4,94.4 c5.3,9.2,15,14.3,24.9,14.2c9.9,0.1,19.6-5.1,24.9-14.2l54.6-94.3C477.1,93.7,461.9,70,440.2,70.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "st0",
    d: "M167.7,429.4L167.7,429.4l-107,0.1c-23.7,0-37.7-22.9-26.3-42.7l54.4-94.4 c5.3-9.2,15-14.3,24.9-14.2c9.9,0,19.6,5.1,24.9,14.2l54.5,94.3C204.6,406.4,189.3,430,167.7,429.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "st1",
    d: "M106.7,105.9l46.2-26.2c33.4-19,76.3-7.2,95.3,26.2l150.7,265.2c4.6,8,1.7,18.3-6.3,22.9 l-46.2,26.2c-33.4,19-76.3,7.2-95.3-26.2L100.4,128.8C95.8,120.8,98.6,110.4,106.7,105.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/loader-logo.9280750dfd2fec9b2fa838243f528fa6.svg";
export { ForwardRef as ReactComponent };